import { create } from "zustand";

const adminNotifStore = create((set) => ({
  adminOrders: [],
  setAdminOrders: (newData) => set({ adminOrders: newData }),
}));

export default adminNotifStore;
